import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Dispatch, useState, RefObject } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { useWorkoutSettings } from "../../../providers/workout-settings";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  type: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const TitleInput = ({ handleErrorRefs, type, dispatch, loading }: Props) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const { activeWorkoutTypes, getWorkoutTypeName } = useWorkoutSettings();
  const handleError = () => {
    setError(type.error);
    setMessage(type.message);
  };
  handleErrorRefs.current?.push(handleError);
  const selectedType = type.input as string;
  const options = activeWorkoutTypes.some(({ id }) => id === selectedType)
    ? activeWorkoutTypes
    : [
        ...activeWorkoutTypes,
        {
          id: selectedType,
          name: getWorkoutTypeName(selectedType),
          active: true,
          bookable: true,
        },
      ].filter(({ id }) => id);

  return (
    <FormControl fullWidth>
      <InputLabel id="type-label">Pass</InputLabel>
      <Select
        error={error}
        disabled={loading}
        onChange={(e) => {
          dispatch({ type: FormInputs.type, payload: e.target.value });
          handleError();
        }}
        label="Workout"
        labelId="type-label"
        id="type"
        value={type.input}>
        {options.map((workoutType) => (
          <MenuItem key={workoutType.id} value={workoutType.id}>
            {workoutType.name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={error}>{message}</FormHelperText>
    </FormControl>
  );
};

export default TitleInput;
